import { Grid, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledGrid = styled(Grid)({
  marginTop: "0"
})

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500]
}))

export const StyledBlackText = styled(Typography)(({ theme }) => ({
  color: theme.palette.foreground.default,
  fontWeight: "500"
}))
